var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaprocess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 84,
    viewBox: "0 0 70 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.879 26.9921V34.0047C30.2813 33.9492 31.711 33.7787 33.1446 33.4973C31.8712 30.7263 30.1368 28.4469 28.879 26.9921Z",
    fill: "url(#paint0_linear_99_501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39.6732H26.9258V35.9906C25.2735 35.9311 23.5938 35.721 21.9102 35.3642C21.4375 36.7239 21.1016 38.1708 20.9961 39.6732L21 39.6732Z",
    fill: "url(#paint1_linear_99_501)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.914 45.9641C23.5976 45.6033 25.2773 45.3972 26.9257 45.3338V41.6511H20.9999C21.1054 43.1536 21.4374 44.6004 21.914 45.9601L21.914 45.9641Z",
    fill: "url(#paint2_linear_99_501)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.766 39.6732H42.7855C42.6332 37.2988 41.9378 35.0708 40.8285 33.1206C39.1605 33.85 37.4808 34.4446 35.8168 34.9005C36.3168 36.3989 36.6644 38.0004 36.766 39.6732Z",
    fill: "url(#paint3_linear_99_501)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.723 31.44C37.4769 28.4828 34.1839 26.3937 30.4105 25.7436C31.8167 27.3689 33.7308 29.9178 35.098 33.0455C36.6332 32.6372 38.18 32.0981 39.723 31.44Z",
    fill: "url(#paint4_linear_99_501)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.926 34.0045V26.996C25.6721 28.4468 23.9416 30.7262 22.6682 33.4931C24.0979 33.7785 25.5237 33.949 26.926 34.0045Z",
    fill: "url(#paint5_linear_99_501)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.992 34.8924C18.324 34.4366 16.6443 33.8379 14.9803 33.1126C13.867 35.0669 13.1717 37.2947 13.0194 39.6731H19.0389C19.1405 37.9964 19.4881 36.3948 19.992 34.8924Z",
    fill: "url(#paint6_linear_99_501)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.398 25.7439C21.6285 26.394 18.3355 28.4831 16.0894 31.4364C17.6285 32.0905 19.1753 32.6296 20.7105 33.0418C22.0777 29.9181 23.9878 27.3692 25.3941 25.7439H25.398Z",
    fill: "url(#paint7_linear_99_501)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.043 41.6552H13.0235C13.1758 44.0337 13.8712 46.2615 14.9844 48.2157C16.6602 47.4863 18.336 46.8917 19.9961 46.4359C19.4922 44.9374 19.1446 43.3319 19.043 41.6552Z",
    fill: "url(#paint8_linear_99_501)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.926 47.3207C25.5276 47.3762 24.1018 47.5466 22.6682 47.836C23.9416 50.5991 25.6721 52.8784 26.926 54.3332V47.3207Z",
    fill: "url(#paint9_linear_99_501)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.09 49.8894C18.3361 52.8427 21.6252 54.9318 25.3986 55.5819C23.9924 53.9566 22.0822 51.4116 20.715 48.2879C19.1877 48.6962 17.6408 49.2353 16.0939 49.8894H16.09Z",
    fill: "url(#paint10_linear_99_501)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.41 55.5815C34.1834 54.9314 37.4764 52.8383 39.7186 49.885C38.1756 49.227 36.6288 48.6878 35.0975 48.2796C33.7303 51.4072 31.8202 53.9563 30.41 55.5815Z",
    fill: "url(#paint11_linear_99_501)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.898 35.3643C32.2144 35.7211 30.5347 35.9272 28.8785 35.9867V39.6694H34.8043C34.6988 38.1709 34.3668 36.7241 33.8941 35.3643L33.898 35.3643Z",
    fill: "url(#paint12_linear_99_501)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.875 62.0195C58.875 59.97 57.8867 58.0395 56.2305 56.8622C55.3086 56.2041 54.25 55.8197 53.1367 55.7324C52.9765 55.7205 52.8164 55.7126 52.6562 55.7126C49.2304 55.7126 46.4414 58.543 46.4414 62.0194C46.4414 64.1878 47.5195 66.1778 49.3242 67.3432C49.5547 67.4899 49.793 67.6207 50.0391 67.7397C50.7227 68.0608 51.4571 68.259 52.2149 68.3105C52.3633 68.3224 52.5078 68.3263 52.6563 68.3263C53.8399 68.3263 54.9883 67.9854 55.9883 67.3432C56.0664 67.2917 56.1406 67.2441 56.207 67.1926C57.8828 65.9954 58.8711 64.0689 58.8711 62.0194L58.875 62.0195Z",
    fill: "url(#paint13_linear_99_501)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.949 79.0572H47.383C45.8674 79.0572 44.4377 79.6558 43.3596 80.742C43.2385 80.8649 43.1252 80.9957 43.0159 81.1265C42.9846 81.1662 42.9534 81.2098 42.9182 81.2494C42.844 81.3445 42.7698 81.4436 42.7034 81.5427L42.6096 81.6854C42.5393 81.7925 42.4768 81.9035 42.4143 82.0184C42.3948 82.0541 42.3713 82.0937 42.3518 82.1294C42.2737 82.2801 42.2034 82.4307 42.137 82.5892C42.1252 82.621 42.1135 82.6566 42.1018 82.6884C42.051 82.8152 42.008 82.9421 41.969 83.0689C41.9534 83.1204 41.9377 83.1759 41.9221 83.2275C41.8909 83.3424 41.8596 83.4614 41.8362 83.5803C41.8245 83.6318 41.8127 83.6833 41.8049 83.7388C41.801 83.7666 41.7971 83.7943 41.7932 83.8221H63.5392C63.0744 81.1185 60.7462 79.0572 57.9533 79.0572L57.949 79.0572Z",
    fill: "url(#paint14_linear_99_501)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.539 78.8309C42.6093 78.7714 42.6835 78.7238 42.7538 78.6683C42.8828 78.5692 43.0078 78.4701 43.1367 78.379C43.2226 78.3195 43.3124 78.2719 43.3984 78.2204C43.5234 78.1451 43.6445 78.0618 43.7695 77.9944C43.8632 77.9429 43.9609 77.9033 44.0585 77.8557C44.1835 77.7962 44.3085 77.7288 44.4335 77.6733C44.5351 77.6297 44.6406 77.598 44.7421 77.5584C44.871 77.5108 44.996 77.4593 45.1249 77.4196C45.2304 77.3879 45.3437 77.3641 45.4491 77.3324C45.5781 77.2968 45.7069 77.2611 45.8398 77.2333C45.953 77.2095 46.0663 77.1976 46.1796 77.1778C46.3124 77.158 46.4413 77.1342 46.5741 77.1184C46.6913 77.1065 46.8046 77.1025 46.9218 77.0985C47.039 77.0906 47.1523 77.0787 47.2695 77.0787L47.7929 68.6826C47.6952 68.6113 47.6015 68.532 47.5077 68.4567C47.4804 68.4329 47.453 68.4131 47.4257 68.3933C47.1679 68.1752 46.9218 67.9414 46.6952 67.6956C46.664 67.6599 46.6327 67.6242 46.6015 67.5885C46.5234 67.5013 46.4452 67.4102 46.3671 67.319C46.328 67.2714 46.2929 67.2238 46.2538 67.1763C46.1874 67.093 46.1249 67.0098 46.0624 66.9266C46.0234 66.8711 45.9882 66.8195 45.9491 66.764C45.8945 66.6808 45.8359 66.6015 45.7851 66.5182C45.746 66.4588 45.7109 66.3993 45.6757 66.3399C45.6249 66.2566 45.578 66.1773 45.5312 66.0901C45.496 66.0267 45.4648 65.9633 45.4296 65.8998C45.3866 65.8166 45.3437 65.7333 45.3046 65.6461C45.2734 65.5827 45.2421 65.5153 45.2148 65.4479C45.1757 65.3607 45.1405 65.2775 45.1054 65.1903C45.078 65.1229 45.0507 65.0555 45.0273 64.9881C44.996 64.9009 44.9648 64.8137 44.9335 64.7225C44.9101 64.6551 44.8866 64.5838 44.8671 64.5164C44.8398 64.4252 44.8124 64.334 44.789 64.2428C44.7694 64.1715 44.7499 64.1041 44.7343 64.0327C44.7109 63.9376 44.6913 63.8425 44.6718 63.7513C44.6562 63.6799 44.6405 63.6126 44.6288 63.5412C44.6093 63.4421 44.5976 63.339 44.5819 63.2399C44.5741 63.1725 44.5624 63.1091 44.5546 63.0417C44.5429 62.9307 44.5312 62.8158 44.5234 62.7048C44.5194 62.6493 44.5116 62.5938 44.5077 62.5343C44.496 62.3639 44.4921 62.1934 44.4921 62.0229C44.4921 57.4523 48.1562 53.7339 52.6601 53.7339C52.9101 53.7339 53.1523 53.7498 53.3984 53.7696C53.4726 53.7775 53.5468 53.7855 53.621 53.7974C53.7968 53.8172 53.9687 53.8449 54.1445 53.8766C54.2226 53.8925 54.2968 53.9044 54.375 53.9202C54.5703 53.9638 54.7617 54.0114 54.9492 54.0669C54.996 54.0788 55.039 54.0907 55.0859 54.1066C55.3203 54.1819 55.5468 54.2651 55.7734 54.3603C55.789 54.3682 55.8046 54.3722 55.8203 54.3761V30.9045C55.7539 30.9045 55.6875 30.8965 55.621 30.8926C55.4921 30.8886 55.3593 30.8807 55.2304 30.8728C55.0976 30.8648 54.9609 30.8529 54.8281 30.841C54.6992 30.8291 54.5703 30.8173 54.4453 30.8014C54.3125 30.7855 54.1797 30.7697 54.0468 30.7499C53.9218 30.73 53.7929 30.7142 53.6679 30.6904C53.539 30.6706 53.4062 30.6428 53.2773 30.619C53.1523 30.5953 53.0273 30.5715 52.9023 30.5437C52.7734 30.516 52.6484 30.4843 52.5195 30.4526C52.3984 30.4208 52.2734 30.3931 52.1523 30.3574C52.0273 30.3217 51.9023 30.2861 51.7773 30.2504C51.6562 30.2147 51.5351 30.179 51.4179 30.1394C51.2968 30.0998 51.1757 30.0561 51.0546 30.0125C50.9375 29.9689 50.8164 29.9293 50.6992 29.8817C50.5781 29.8342 50.4609 29.7866 50.3437 29.739C50.2265 29.6915 50.1093 29.6439 49.996 29.5923C49.8789 29.5408 49.7656 29.4893 49.6484 29.4338C49.5351 29.3822 49.4218 29.3267 49.3085 29.2712C49.1953 29.2158 49.082 29.1563 48.9726 29.0968C48.8632 29.0374 48.7499 28.9779 48.6406 28.9184C48.5312 28.855 48.4218 28.7916 48.3164 28.7282C48.207 28.6647 48.0976 28.6013 47.9921 28.5339C47.8867 28.4665 47.7812 28.3991 47.6796 28.3317C47.5742 28.2604 47.4687 28.193 47.3632 28.1216C47.2617 28.0503 47.1601 27.9789 47.0624 27.9036C46.9609 27.8283 46.8554 27.753 46.7578 27.6777C46.6601 27.6023 46.5624 27.5231 46.4687 27.4478C46.371 27.3685 46.2695 27.2892 46.1718 27.2059C46.0781 27.1267 45.9843 27.0434 45.8945 26.9602C45.8007 26.8769 45.7031 26.7937 45.6093 26.7065C45.5195 26.6232 45.4335 26.536 45.3437 26.4528C45.2499 26.3616 45.1601 26.2744 45.0703 26.1832C44.9843 26.096 44.9023 26.0048 44.8203 25.9176C44.7304 25.8225 44.6445 25.7313 44.5585 25.6322C44.4765 25.541 44.3984 25.4459 44.3203 25.3547C44.2382 25.2556 44.1523 25.1604 44.0703 25.0574C43.9921 24.9622 43.9218 24.8631 43.8476 24.768C43.7695 24.6649 43.6874 24.5658 43.6093 24.4588C43.539 24.3637 43.4726 24.2606 43.4023 24.1615C43.3281 24.0545 43.2499 23.9474 43.1757 23.8364C43.1093 23.7373 43.0507 23.6382 42.9882 23.5391C42.914 23.4242 42.8398 23.3092 42.7695 23.1942C42.7148 23.0991 42.6601 23.004 42.6093 22.9088C42.3476 22.449 42.1054 21.9693 41.8867 21.4818C41.8398 21.3748 41.789 21.2717 41.746 21.1647C41.6953 21.0418 41.6484 20.9189 41.6015 20.792C41.5585 20.6771 41.5078 20.5621 41.4687 20.4472C41.4257 20.3243 41.3828 20.1974 41.3437 20.0745C41.3046 19.9556 41.2617 19.8367 41.2226 19.7138C41.1835 19.5909 41.1523 19.4641 41.1171 19.3372C41.082 19.2143 41.0468 19.0914 41.0117 18.9646C40.9804 18.8377 40.9531 18.7109 40.9218 18.5801C40.8945 18.4532 40.8632 18.3264 40.8359 18.1995C40.8085 18.0726 40.789 17.9418 40.7656 17.811C40.7421 17.6802 40.7187 17.5533 40.6953 17.4225C40.6757 17.2917 40.6601 17.1609 40.6445 17.0301C40.6289 16.8993 40.6093 16.7685 40.5937 16.6337C40.5781 16.5029 40.5703 16.3681 40.5585 16.2373C40.5468 16.1025 40.5351 15.9677 40.5273 15.8329C40.5195 15.6982 40.5156 15.5673 40.5117 15.4326C40.5117 15.3255 40.5 15.2185 40.5 15.1115H-0.00804901V83.8134H39.812C39.8276 83.6905 39.851 83.5716 39.8745 83.4487C39.8862 83.3774 39.894 83.306 39.9096 83.2386C39.9565 83.0087 40.0112 82.7827 40.0776 82.5607C40.0854 82.529 40.101 82.4973 40.1088 82.4656C40.1674 82.2753 40.2338 82.089 40.308 81.9027C40.3354 81.8313 40.3705 81.76 40.4018 81.6847C40.4643 81.542 40.5268 81.4032 40.5971 81.2645C40.6362 81.1852 40.6791 81.1099 40.7221 81.0346C40.7924 80.9037 40.8705 80.7769 40.9487 80.65C40.9955 80.5747 41.0424 80.5034 41.0893 80.432C41.1791 80.3012 41.2729 80.1704 41.3745 80.0435C41.4213 79.9841 41.4643 79.9246 41.5112 79.8652C41.6596 79.6828 41.8159 79.5044 41.9838 79.3379C42.1635 79.1556 42.351 78.9851 42.5424 78.8266L42.539 78.8309ZM38.4062 76.1551H18.0622C17.5231 76.1551 17.0856 75.7111 17.0856 75.1641C17.0856 74.617 17.5231 74.1731 18.0622 74.1731H38.4062C38.9453 74.1731 39.3828 74.617 39.3828 75.1641C39.3828 75.7111 38.9453 76.1551 38.4062 76.1551ZM38.4062 67.4499H9.2852C8.74614 67.4499 8.30864 67.006 8.30864 66.4589C8.30864 65.9119 8.74614 65.4679 9.2852 65.4679H38.4062C38.9453 65.4679 39.3828 65.9119 39.3828 66.4589C39.3828 67.006 38.9453 67.4499 38.4062 67.4499ZM27.9022 57.7815C18.6014 57.7815 11.0312 50.103 11.0312 40.6605C11.0312 37.2632 12.0156 34.0959 13.7031 31.432C13.7383 31.3567 13.7812 31.2893 13.832 31.2299C16.8554 26.6037 22.0312 23.5434 27.898 23.5434C33.7691 23.5434 38.945 26.6037 41.968 31.2338C42.0188 31.2972 42.0657 31.3646 42.1008 31.4439C43.7844 34.1078 44.7688 37.2712 44.7688 40.6644C44.7688 44.0576 43.7805 47.2449 42.0813 49.9167C42.0501 49.9801 42.0149 50.0356 41.9719 50.0871C38.9485 54.7212 33.7688 57.7854 27.8979 57.7854L27.9022 57.7815Z",
    fill: "url(#paint15_linear_99_501)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.582 69.7615C55.1289 69.9359 54.664 70.0707 54.1875 70.1618C54.1797 70.1618 54.168 70.1619 54.1602 70.1658C53.668 70.257 53.168 70.3125 52.6602 70.3125C52.1523 70.3125 51.6563 70.261 51.168 70.1698C51.1562 70.1698 51.1445 70.1658 51.1328 70.1618C50.6601 70.0707 50.1953 69.9399 49.7461 69.7654C49.7266 69.7575 49.707 69.7535 49.6875 69.7456L49.2305 77.0793H56.0938L55.6367 69.7456C55.6367 69.7456 55.6016 69.7575 55.5821 69.7654L55.582 69.7615Z",
    fill: "url(#paint16_linear_99_501)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.879 47.3199V54.3284C30.1368 52.8735 31.8634 50.5942 33.1407 47.8273C31.7032 47.5419 30.2774 47.3714 28.879 47.3199Z",
    fill: "url(#paint17_linear_99_501)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.227 0.955921C48.8989 0.955921 42.852 6.76736 42.465 14.184C42.4494 14.4338 42.4416 14.6835 42.4416 14.9372C42.4416 22.6475 48.6252 28.9224 56.2266 28.9224C56.4063 28.9224 56.5781 28.9224 56.7539 28.9105C64.1875 28.6251 70.0079 22.4886 70.0079 14.9365C70.0079 7.38485 63.8243 0.947266 56.2269 0.947266L56.227 0.955921ZM63.0825 12.0671L56.0356 19.2184C55.8442 19.4127 55.5942 19.5078 55.3442 19.5078C55.0942 19.5078 54.8442 19.4127 54.6528 19.2184L49.3676 13.8549C48.9848 13.4664 48.9848 12.8401 49.3676 12.4516C49.7504 12.0632 50.3676 12.0632 50.7504 12.4516L55.3442 17.1135L61.6997 10.6638C62.0825 10.2754 62.6997 10.2754 63.0825 10.6638C63.4653 11.0523 63.4653 11.6787 63.0825 12.0671Z",
    fill: "url(#paint18_linear_99_501)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.809 41.6552H28.8832V45.3378C30.5277 45.3973 32.2074 45.6034 33.8988 45.9602C34.3715 44.6005 34.7074 43.1536 34.809 41.6552Z",
    fill: "url(#paint19_linear_99_501)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.766 41.6552C36.6644 43.328 36.3168 44.9296 35.8168 46.4279C37.4809 46.8838 39.1606 47.4824 40.8285 48.2118C41.9418 46.2575 42.6332 44.0296 42.7855 41.6552H36.766Z",
    fill: "url(#paint20_linear_99_501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_99_501",
    x1: 39.3011,
    y1: 41.6552,
    x2: 39.3011,
    y2: 48.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_99_501",
    x1: 34.9999,
    y1: 0.947266,
    x2: 34.9999,
    y2: 83.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_99_501",
    x1: 39.3011,
    y1: 41.6552,
    x2: 39.3011,
    y2: 48.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_99_501",
    x1: 39.3011,
    y1: 41.6552,
    x2: 39.3011,
    y2: 48.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaprocess);
export default __webpack_public_path__ + "static/media/Visa process.e35a08a2496aaa22af85a51cfebecfe0.svg";
export { ForwardRef as ReactComponent };